import React, { useState, useEffect, useRef } from "react";
import { useUserAssignableInTicket } from "../../utils/ticket/TicketAssignable";

export function TicketAssignableSelector({ value, onChange, isInvalid, disabled }) {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  const { data, loading, errorMsg, fecthUser } = useUserAssignableInTicket({ filter: {} });

  useEffect(() => {
    fecthUser({});
  }, [fecthUser]);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      fecthUser({ q: search });
    }, 300);
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [search, fecthUser]);

  useEffect(() => {
    if (value && data.length > 0) {
      const user = data.find((u) => u.id === value);
      if (user) {
        setSelectedUser(user);
      }
    }
  }, [value, data]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = (user) => {
    setSelectedUser(user);
    onChange(user?.id || "");
    setIsOpen(false);
    setSearch("");
  };

  const handleClear = () => {
    setSelectedUser(null);
    onChange("");
    setSearch("");
  };

  return (
    <div className="TicketAssignableSelector" ref={wrapperRef}>
      <div className={`dropdown ${isOpen ? "show" : ""}`}>
        <div
          className={`form-control d-flex justify-content-between align-items-center ${isInvalid ? "is-invalid" : ""}`}
          style={{ cursor: "pointer", minHeight: "38px" }}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          {selectedUser ? (
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {selectedUser.name || selectedUser.email}
            </span>
          ) : (
            <span className="text-muted">-- Penugasan --</span>
          )}
          <div className="d-flex align-items-center">
            {selectedUser && (
              <button
                type="button"
                className="close mr-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClear();
                }}
                style={{ fontSize: "14px" }}
              >
                <i className="fa fa-chevron-down"></i>
              </button>
            )}
            {loading && <span className="spinner-border spinner-border-sm mr-1"></span>}
          </div>
        </div>
        {isOpen && (
          <div
            className="dropdown-menu show w-100"
            style={{ maxHeight: "300px", paddingBottom: "0" }}
          >
            <div className="px-2 pb-2 border-bottom" style={{ flexShrink: 0 }}>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Cari..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus
              />
            </div>
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {errorMsg && <div className="px-3 py-2 text-danger">{errorMsg}</div>}
              {data.map((user) => (
                <button
                  key={user.id}
                  className={`dropdown-item ${selectedUser?.id === user.id ? "active" : ""}`}
                  style={{
                    fontSize: "14px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => handleSelect(user)}
                >
                  {user.name || user.email}
                </button>
              ))}
              {data.length === 0 && !loading && (
                <div className="px-3 py-2 text-muted">Tidak ada data</div>
              )}
            </div>
          </div>
        )}
      </div>
      {isInvalid && <div className="invalid-feedback d-block">{isInvalid}</div>}
    </div>
  );
}
